import { Controller } from "@hotwired/stimulus"

// Datepicker: flatpickr (calendário, locale pt, d/m/Y) + IMask (auto-barra ao digitar).
// Ambos globais via Sprockets. Server espera dd/mm/yyyy. IMask criado ANTES do flatpickr;
// ao setar a data pelo calendário, ressincronizamos o IMask (updateValue) p/ não dessincronizar.
export default class extends Controller {
  connect() {
    if (typeof flatpickr === "undefined") return

    if (typeof IMask !== "undefined") {
      this.mask = IMask(this.element, { mask: "00/00/0000" })
    }

    this.fp = flatpickr(this.element, {
      locale: "pt",
      dateFormat: "d/m/Y",
      allowInput: true,
      onChange: () => this._syncMask(),
      onValueUpdate: () => this._syncMask()
    })
  }

  _syncMask() {
    // flatpickr setou input.value direto (calendário) — ressincroniza o IMask
    if (this.mask) this.mask.updateValue()
  }

  disconnect() {
    if (this.fp) { this.fp.destroy(); this.fp = null }
    if (this.mask) { this.mask.destroy(); this.mask = null }
  }
}
